import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack,
    Grid,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CheckIcon from "@mui/icons-material/Check";
import CancelIcon from "@mui/icons-material/Cancel";

export default function EditFamilyMemberDialog({ open, onClose, onSave, member }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [socialNumber, setSocialNumber] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);

    useEffect(() => {
        if (member) {
            setFirstName(member.firstName || "");
            setLastName(member.lastName || "");
            setSocialNumber(member.socialNumber || "");
            setDateOfBirth(
                member.dateOfBirth ? dayjs(member.dateOfBirth, "DD-MM-YYYY") : null
            );
        }
    }, [member]);

    const handleSave = () => {
        const updatedMember = {
            ...member,
            firstName,
            lastName,
            socialNumber,
            dateOfBirth: dateOfBirth ? dateOfBirth.format("DD-MM-YYYY") : null,
        };
        onSave(updatedMember);
    };

    const handleCancel = () => {
        onClose();
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>Familienmitglied bearbeiten</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label="Vorname"
                        variant="standard"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Nachname"
                        variant="standard"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Sozialversicherungsnummer"
                        variant="standard"
                        value={socialNumber}
                        onChange={(e) => setSocialNumber(e.target.value)}
                        fullWidth
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Geburtsdatum"
                            value={dayjs(dateOfBirth, 'DD-MM-YYYY')}
                            format="DD-MM-YYYY"
                            disableMaskedInput
                            onChange={(newValue) => setDateOfBirth(newValue)}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: "standard",
                                },
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%', marginBottom: '5px'}}>
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<CheckIcon />}
                        onClick={handleSave}
                    >
                        Speichern
                    </Button>

                    <Button
                        variant="outlined"
                        startIcon={<CancelIcon />}
                        onClick={handleCancel}
                    >
                        Stornieren
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}